/*
---
author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var FormSupport = new Class({
	Implements: [Events, Options],

	options: {
		validation: true,
		native_submit: true
	},

	initialize: function(form, options){
		if(!form || form.supported) return;

		this.setOptions(options);
		this._form = form;
		this._form.supported = true;

		this.build();
	},

	build: function(){
		this._form.addEvents({
			submit: function(e){
				if(!this.options.native_submit && e && e.stop){
					e.stop();
				}

				// var category = this.options.category || window.pageType;
				// if (category && this.options.action) {
				// 	// console.log('FormSupport', category, this.options.action, this.options.label);
				// 	_gaq.push(['_trackEvent', category, this.options.action, this.options.label]);
				// }

				this.fireEvent('submit', [this._form.is_valid]);
			}.bind(this)
		});

		this._form.getElements('.errorMessage').each(function(_el){
			var _parent = _el.getParent('li');

			if(_parent){
				_parent.addClass('_failed');
			}
		});

		this.style_fields();
		this.style_checkboxes();
		this.style_radios();

		if(this.options.validation){
			this.add_validator();
		}else{
			this._form.is_valid = true;
		}
	},

	style_fields: function(){
		var _fields = this._form.getElements('[type="text"], [type="password"], textarea');

		_fields.each(function(_el){
			if(_el.getAttribute('self-overtext') != 'true'){
				if(_el.getAttribute('get-title')){
					var _label = _el.getPrevious('label') || _el.getNext('label');

					if(_label){
						var _span = _label.getElement('span.asterisk');

						if(_span){
							_span.dispose();
						}

						var title = _label.get('text');
						_el.setAttribute('title', title);

						_label.dispose();
					}
				}

				if(!_el.getProperty('placeholder')){
					new TextOver(_el);
				}
			}

			if(_el.getProperty('disabled')){
				_el.getParent().addClass('_disabled');
			}

			_el.addEvents({
				'focus': function(e){
					_el.getParent().addClass('_focused');
				},

				'blur': function(){
					_el.getParent().removeClass('_focused');
				}
			});
		});
	},

	style_checkboxes: function(){
		var _checkboxes = this._form.getElements('.w_styled_checkbox');

		if(_checkboxes && _checkboxes.length > 0){
			_checkboxes.each(function(_el){
				new StyledCheckbox(_el);
			});
		}
	},

	style_radios: function(){
		this._form.getElements('.w_styled_radio').each(function(_el){
			var checked = false;
			var _lis = _el.getElements('li');

			_lis.each(function(_e){
				var _radio = _e.getElement('input[type="radio"]');

				if(_radio && _radio.checked){
					_e.addClass('_selected');
					checked = true;
				}

				_e.addEvent('click', function(){
					if(_e.hasClass('_selected')) return;

					var _selected = _el.getElement('._selected');

					if(_selected){
						_selected.removeClass('_selected');
					}

					_e.addClass('_selected');

					if(_radio){
						_radio.checked = true;
					}
				});
			});

			if(!checked && _lis.length > 0){
				var _radio = _lis[0].getElement('input[type="radio"]');

				if(_radio){
					_lis[0].fireEvent('click');
				}
			}
		});
	},

	add_validator: function(){
		new Form.Validator.Inline(this._form, {
			errorPrefix: '',
			evaluateFieldsOnBlur: false,
			evaluateFieldsOnChange: false,
			scrollToErrorsOnSubmit: false,

			onFormValidate: function(passed, _form, e){
				_form.is_valid = passed;

				_form.getElements('li').each(function(_el){
					if(!_el.getElement('.errorMessage')){
						if(!_el.getAttribute('data-failed')){
							_el.removeClass('_failed');
						}
					}

					var _label = _el.getElement('label');
					if(_label) _label.removeClass('failed');
				});

				if(!passed || _form.getElement('._failed')){
					_form.addClass('has_errors');

					_form.getElements('.validation-failed').each(function(_el){
						var _li = _el.getParent('li');

						if(!_li) return;

						var _error = _li.getElement('.errorMessage');
						if(_error) _error.dispose();

						_li.addClass('_failed');

						if(_li.getElement('label')){
							_li.getElement('label').addClass('failed');
						}
					});

					var _lis = _form.getElements('li');

					_lis.each(function(_li){
						var _advices = _li.getElements('.validation-advice');

						if(_advices.length > 1){
							(function(){
								if(_li.getElement('input').get('id') == 'FormResetPasswordChange_password' && _li.getElement('input').get('value') == ''){
									_advices[0].dispose();
								}
								else{
									_advices[1].dispose();
								}
							}.delay(100));
						}
					});
				}else{
					_form.removeClass('has_errors');
					_form.fireEvent('validationPassed', [e]);
				}
			}
		});

		if(!Locale_is_defined){
			Locale.define('en-US', 'FormValidator', {
				email: 'Please enter a valid email address.',
				minLength: 'Please enter at least {minLength} characters',
				digits: 'Please use numbers and punctuation only'
			});

			Locale_is_defined = true;
		}
	}
});
